export default __webpack_public_path__ + "media/images/features/ambassador/mv_sp-e95106b0b1d87507fcf439f7d7e74743.jpg";